import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { ValidateWord } from "components/atoms/text/Text";
import { SearchUsers } from "components/element/search/SearchUsers";
import { UserGroupCURequest } from "api/interfaces/userInterface.interface";
import { UPDATE_TYPE } from "../AddUserGroupContainer";

interface UsersStepPageProps {
  accountId: string;
  groupId?: string;
  isEditableUser: boolean;
  userGroup: UserGroupCURequest;
  usersValidateMsg: string;
  onChangeGroupInfo: (type: UPDATE_TYPE, value: any) => void;
}

export default function UsersStepPage(props: UsersStepPageProps): JSX.Element {
  return (
    <ModalInput label="Add Users">
      <SearchUsers
        isEditUserGroup={props.isEditableUser}
        isTab={false}
        userGroupId={props.groupId ?? ""}
        accountId={props.accountId}
        selectedUserId={props.userGroup.users}
        onSelectedRowsChangeUser={(value: string[]) => {
          props.onChangeGroupInfo(UPDATE_TYPE.USERS, value);
        }}
      />
      <ValidateWord>{props.usersValidateMsg}</ValidateWord>
    </ModalInput>
  );
}
